'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _reactBootstrap = require('react-bootstrap');

var _components = {
	_$FileUpload: {
		displayName: 'FileUpload'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var FileUpload = (function (_Component) {
	_inherits(FileUpload, _Component);

	function FileUpload(props) {
		_classCallCheck(this, _FileUpload);

		_Component.call(this, props);
		this.uid = _uuid2['default'].v4();
		this.state = {
			busy: false,
			overed: false,
			files: [],
			value: props.value ? props.value.toJS() : []
		};
	}

	FileUpload.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value ? nextProps.value.toJS() : [] });
	};

	FileUpload.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.uploader = new plupload.Uploader({
			runtimes: 'html5,html4',
			multi_selection: true,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button: this.uid + '_pickfiles',
			url: '/upload/file',
			filters: {
				max_file_size: '100mb'
			},
			init: {
				FilesAdded: function FilesAdded(up, files) {
					plupload.each(files, function (file) {
						_this.handleFileAdd(file);
					});
					_this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function Error(up, err) {
					alert(err.message);
				}
			}
		});
		this.uploader.init();
	};

	FileUpload.prototype.componentWillUnmount = function componentWillUnmount() {
		this.uploader.destroy();
	};

	FileUpload.prototype.startUpload = function startUpload() {
		this.setState({ busy: true });
		this.uploader.start();
	};

	FileUpload.prototype.handleFileAdd = function handleFileAdd(file) {
		this.state.files.push(file);
		this.forceUpdate();
	};

	FileUpload.prototype.handleUploadProgress = function handleUploadProgress(up, file) {
		this.forceUpdate();
	};

	FileUpload.prototype.handleFileUploaded = function handleFileUploaded(up, file, response) {
		response = JSON.parse(response.response);
		var o = { title: file.name, url: '/file/download-tmp/?file=' + response.file + '&name=' + encodeURIComponent(file.name), file: response.file, id: -Math.random() };
		this.state.value.push(o);
		this.setState({ value: this.state.value });
	};

	FileUpload.prototype.handleUploadComplete = function handleUploadComplete(up, files) {
		this.setState({ files: [], busy: false });
		this.changedValue();
	};

	FileUpload.prototype.handleClick = function handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	};

	FileUpload.prototype.changedValue = function changedValue() {
		var value = _immutable2['default'].fromJS(this.state.value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	};

	FileUpload.prototype.handleDelete = function handleDelete(id) {
		this.state.value = this.state.value.filter(function (file) {
			return file.id != id;
		});
		this.changedValue();
	};

	FileUpload.prototype.dragEnter = function dragEnter(e) {
		this.setState({ overed: true });
	};

	FileUpload.prototype.dragLeave = function dragLeave(e) {
		this.setState({ overed: false });
	};

	FileUpload.prototype.renderInput = function renderInput() {
		var _this2 = this;

		var files = this.state.files.filter(function (file) {
			return file.status != plupload.DONE;
		}).map(function (file) {
			return _react2['default'].createElement(
				'tr',
				{ key: file.id },
				_react2['default'].createElement(
					'td',
					null,
					file.name
				),
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement('span', { className: 'fa fa-circle-o-notch spinner' })
				)
			);
		});
		var value = this.state.value.map(function (file) {
			return _react2['default'].createElement(
				'tr',
				{ key: file.id },
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement(
						'a',
						{ href: file.url },
						file.title
					)
				),
				_react2['default'].createElement(
					'td',
					{ onClick: function (e) {
							return _this2.handleDelete(file.id);
						}, style: { cursor: 'pointer' } },
					_react2['default'].createElement('span', { className: 'icon-cross3' })
				)
			);
		});

		return _react2['default'].createElement(
			'table',
			{ id: this.uid + '_dropzone', onClick: this.handleClick },
			_react2['default'].createElement(
				'tbody',
				null,
				_react2['default'].createElement(
					'tr',
					null,
					_react2['default'].createElement(
						'td',
						{ colSpan: '2' },
						_react2['default'].createElement(
							'table',
							{ style: { width: '100%' } },
							_react2['default'].createElement(
								'tbody',
								null,
								value,
								files
							)
						)
					)
				),
				_react2['default'].createElement(
					'tr',
					null,
					_react2['default'].createElement(
						'td',
						{ className: 'imageupload' },
						_react2['default'].createElement(
							'a',
							{ id: this.uid + '_pickfiles', className: 'btn btn-default btn-xs', href: 'javascript:;' },
							_react2['default'].createElement('i', { className: 'fa fa-folder-open-o' }),
							'  Vybrat soubory'
						)
					),
					_react2['default'].createElement(
						'td',
						{ className: _classnames2['default']('dropzone', { 'overed': this.state.overed }),
							onDragEnter: this.dragEnter.bind(this),
							onDrop: this.dragLeave.bind(this),
							onDragLeave: this.dragLeave.bind(this) },
						'Přetáhněte soubory sem'
					)
				)
			)
		);
	};

	FileUpload.prototype.renderError = function renderError() {
		return this.props.error ? _react2['default'].createElement("span", { className: "error-block", key: "error" }, this.props.error) : null;
	};

	FileUpload.prototype.renderWrapper = function renderWrapper(children) {
		return this.props.wrapperClassName ? _react2['default'].createElement("div", { className: this.props.wrapperClassName, key: "wrapper" }, children) : children;
	};

	FileUpload.prototype.renderFormGroup = function renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return _react2['default'].createElement("div", { className: _classnames2['default'](classes) }, children);
	};

	FileUpload.prototype.render = function render() {
		return this.renderFormGroup([this.renderWrapper([this.renderInput()]), this.renderError()]);
	};

	var _FileUpload = FileUpload;
	FileUpload = _wrapComponent('_$FileUpload')(FileUpload) || FileUpload;
	return FileUpload;
})(_Component2['default']);

exports['default'] = FileUpload;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/FileUpload.js
 ** module id = 1011
 ** module chunks = 1
 **/